"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMatic = void 0;
const maticjs_1 = require("@maticnetwork/maticjs");
const maticjs_web3_1 = require("@maticnetwork/maticjs-web3");
const ethers_1 = require("ethers");
// install ethers plugin
(0, maticjs_1.use)(maticjs_web3_1.Web3ClientPlugin);
// get matic and maticPoS clients from maticjs
const initMatic = async (isMainnet, maticRPC, ethereumRPC) => {
    const _network = isMainnet ? "mainnet" : "testnet";
    const _version = isMainnet ? "v1" : "mumbai";
    const maticConfig = {
        network: _network,
        version: _version,
        parent: {
            provider: ethereumRPC,
            defaultConfig: {
                from: ethers_1.constants.AddressZero,
            },
        },
        child: {
            provider: maticRPC,
            defaultConfig: {
                from: ethers_1.constants.AddressZero,
            },
        },
    };
    const posClient = new maticjs_1.POSClient();
    await posClient.init(maticConfig);
    return posClient;
};
exports.initMatic = initMatic;
//# sourceMappingURL=client.js.map